.content {
  overflow-y: auto;
  max-height: 32rem;

  @media screen and (max-width: #{$bp-small - 1}) {
    max-width: 100vw;
  }
}

.trigger {
  all: unset;
  width: 2.8rem;
  height: 2.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 2.8rem;
  font-size: 1.8rem;
  border-radius: 0.4rem;
  transition: 0.1s ease-in background-color;
  user-select: none;
  background-color: var(--color-grayscale-tuna);
  color: var(--color-grayscale-manatee);

  &:hover {
    cursor: pointer;
  }

  &[data-size='large'] {
    width: 3.2rem;
    height: 3.2rem;
  }

  &[data-size='free-size'] {
    width: unset;
    height: unset;
  }
}

.menu-modal {
  opacity: 2;
  min-width: 18rem;
  border-radius: 0.6rem;
  padding: 0.4rem;
  z-index: calc(var(--layer-modal) + 1);
  box-shadow: rgba(0, 0, 0, 0.2) 0 4px 24px;
  backdrop-filter: blur(10px) saturate(190%) contrast(70%) brightness(80%);
  background-color: rgba(29, 30, 43, 0.498);

  &[data-size='free-size'] {
    min-width: unset;
  }
}
